/**
 * check if parameter is not null or undefined. With type guard.
 * https://github.com/microsoft/TypeScript/issues/20707#issuecomment-351874491
 */
export function notUndefinedOrNull<T>(x: T | undefined | null): x is T {
    return x !== undefined && x !== null
}
